module.exports = __webpack_public_path__ + "img/id_id.dfc3dd50.png";